import axios from '@/plugins/axios'
import { Module } from 'vuex'

const auditModule: Module<any, any> = {
    actions: {
        async getAuditLogs(_, params) {
            const page = params?.page ?? 1
            const perPage = params?.perPage ?? 10

            let url = `/api/audit_logs?page=${page}&itemPerPage=${perPage}`

            url += params?.content ? `&content=${params.content}` : ''
            url += params?.actorWorkspaceMember
                ? `&actorWorkspaceMember=${params.actorWorkspaceMember}`
                : ''
            url += params?.changeType ? `&changeType=${params.changeType}` : ''

            if (params?.dateRange) {
                url += params.dateRange?.from
                    ? `&changeDate[from]=${params.dateRange.from}`
                    : ''
                url += params.dateRange?.to
                    ? `&changeDate[to]=${params.dateRange.to}`
                    : ''
            }

            const { data } = await axios.get(url)
            return data
        },
    },
}

export default auditModule
